module.exports = __webpack_public_path__ + "static/5-dc10e8cbfa7a081b9a9ab09dfce6689a.png";